import { InterestProperty } from "@/modules/lead-page/types";
import { Box, Typography } from "@mui/material";

export default function ActivityHistoryHeader({
  interest,
}: {
  interest: InterestProperty;
}) {
  return (
    <Box>
      <Typography
        sx={(t) => t.nawy.typography.english.variants.body.md.semibold}
      >
        {interest.property.propertyType?.name} in{" "}
        {interest.property.compound?.name} activity
      </Typography>
      <Typography
        sx={(t) => ({
          ...t.nawy.typography.english.variants.body.xs.regular,
          color: t.nawy.colors.semantic.text.secondary,
        })}
      >
        ID {interest.property.unitId}
      </Typography>
    </Box>
  );
}
